import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Events from "../pages/events/page";
import Resources from "../pages/resources/page";
import Guides from "../pages/guides/page";
import Contact from "../pages/contact/page";
import Login from "../pages/login/page";
import Blog from "../pages/blog/page";
import BlogDetail from "../pages/blog/BlogDetail";
import GcseTopics from "../pages/gcse/topics/page";
import GcsePastPapers from "../pages/gcse/past-papers/page";
import GcseResources from "../pages/gcse/resources/page";
import GcseMockExams from "../pages/gcse/mock-exams/page";
import ALevelTopics from "../pages/alevel/topics/page";
import ALevelPastPapersPage from "../pages/alevel/past-papers/page";
import ALevelResources from "../pages/alevel/resources/page";
import ALevelMockExams from "../pages/alevel/mock-exams/page";
import Programming from "../pages/programming/page";
import AdminLogin from "../pages/admin/login/page";
import AdminRegister from "../pages/admin/register/page";
import AdminDashboard from "../pages/admin/dashboard/page";
import TutorLogin from "../pages/tutor/login/page";
import TutorDashboard from "../pages/tutor/dashboard/page";
import StudentDashboard from "../pages/student/dashboard/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  // GCSE Resources
  { path: "/gcse/topics", element: <GcseTopics /> },
  { path: "/gcse/past-papers", element: <GcsePastPapers /> },
  { path: "/gcse/resources", element: <GcseResources /> },
  { path: "/gcse/mock-exams", element: <GcseMockExams /> },
  // A Level Resources
  { path: "/alevel/topics", element: <ALevelTopics /> },
  { path: "/alevel/past-papers", element: <ALevelPastPapersPage /> },
  { path: "/alevel/resources", element: <ALevelResources /> },
  { path: "/alevel/mock-exams", element: <ALevelMockExams /> },
  // Programming
  { path: "/programming", element: <Programming /> },
  // Legacy / other pages
  { path: "/syllabus", element: <GcseTopics /> },
  { path: "/events", element: <Events /> },
  { path: "/resources", element: <Resources /> },
  { path: "/guides", element: <Guides /> },
  { path: "/guides/:id", element: <Guides /> },
  { path: "/blog", element: <Blog /> },
  { path: "/blog/:slug", element: <BlogDetail /> },
  { path: "/contact", element: <Contact /> },
  { path: "/login", element: <Login /> },
  // Admin
  { path: "/admin/login", element: <AdminLogin /> },
  { path: "/admin/register", element: <AdminRegister /> },
  { path: "/admin/dashboard/*", element: <AdminDashboard /> },
  // Tutor
  { path: "/tutor/login", element: <TutorLogin /> },
  { path: "/tutor/dashboard", element: <TutorDashboard /> },
  // Student
  { path: "/student/dashboard", element: <StudentDashboard /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
